export function hasPermission(permission) {
    let uprms = JSON.parse(localStorage.getItem('user_permissions'));
    return  (permission in  uprms);
}